import React from "react";

export const ClayButton = ({
  children,
  onClick,
  variant = "primary",
  color,
  borderColor,
  className = "",
  disabled = false,
  type = "button",
  size = "md",
  ...rest
}) => {
  const sizeClasses = {
    sm: "px-5 py-2.5 text-base",
    md: "px-7 py-3.5 text-lg",
    lg: "px-9 py-5 text-xl",
  };

  const baseClasses = `clay-btn inline-flex items-center justify-center gap-2 font-bold rounded-full border-b-[6px] active:border-b-0 disabled:opacity-50 disabled:cursor-not-allowed ${sizeClasses[size]} ${className}`;

  if (variant === "secondary") {
    return (
      <button
        type={type}
        onClick={onClick}
        disabled={disabled}
        className={`${baseClasses} bg-white text-[#1C1C1E] border-2 border-b-[6px] border-gray-200 hover:bg-gray-50`}
        {...rest}
      >
        {children}
      </button>
    );
  }

  if (variant === "ghost") {
    return (
      <button
        type={type}
        onClick={onClick}
        disabled={disabled}
        className={`inline-flex items-center justify-center gap-2 font-bold rounded-full px-5 py-2.5 text-base text-[#5C5C60] hover:bg-white/70 transition-colors ${className}`}
        {...rest}
      >
        {children}
      </button>
    );
  }

  // primary or custom color
  const bg = color || "#FF9500";
  const border = borderColor || "#CC7700";
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseClasses} text-white`}
      style={{ backgroundColor: bg, borderBottomColor: border }}
      {...rest}
    >
      {children}
    </button>
  );
};

export default ClayButton;
